import Vue from 'vue'
import Qs from 'qs'
import router from '@/router'
import store from '@/store'
import { confirmLogin } from '@/utils/util'
import { toMicroApp, microAppInterception } from '@/utils/microTools'
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { asyncRouterMap } from '@/router/router.config'
import cookies from '@/plugin/cookie'
import { mitoLog } from '@/utils/mitojs'

const whiteList = ['CommonLogin', 'ForgetPwd', 'RVerifyPhone', 'RSetPassword', 'RDone', 'User'] // no redirect whitelist

function queryUserInfo() {
  return store
    .dispatch('GetInfo')
    .then(res => {
      if (res) {
        router.addRoutes(asyncRouterMap)
        // 获取灵心的菜单权限
        store.dispatch('getAgentMenuInfo')
        // 获取是否有已授权的智能体
        store.dispatch('getUserAgent')
        // 获取本地缓存的是否显示灵心图标
        const flag = localStorage.getItem(`${res.mobile}_showRobotIcon`) !== '0'
        store.commit('setShowRoobtIcon', flag)
      } else {
        store.dispatch('ClearToken')
      }
    })
    .catch(_err => {
      console.log(_err)
      notification.error({
        message: '错误2',
        description: _err.msg || '请求用户信息失败，请重试'
      })
      store.dispatch('ClearToken')
      // next({ path: '/login' })
      console.log(Vue.prototype)
      confirmLogin()
    })
}

// 有用户信息后的跳转判断
function judgeJump(to, from, next) {
  const finalLevel = Vue.prototype.$cookie.get('finalLevel')
  if (finalLevel) {
    // Vue.prototype.$router.push({ name: Vue.prototype.$cookie.get('finalLevel') })
    next({ name: finalLevel })
    return false
  }
  // next({ name: 'OssCompany' })
  if ((to.path === '/main_home' || to.path === '/') && from.path === '/login/page') {
  // if (from.path === '/login/page') {
    // 如果路由是从登录页到主页
    if (store.getters.accountStatus === 'INIT') {
      // 如果当前用户还未激活则进入首次登录页面
      next({ name: 'First', query: { mobile: store.getters.mobile, areaCode: store.getters.areaCode } })
    } else if (store.getters.defaultPwdFlag) {
      // 如果当前用户使用的是默认密码则进入修改初始密码页面
      next({ name: 'ChangeInitPwd', query: { mobile: store.getters.mobile, areaCode: store.getters.areaCode } })
    } else {
      next({ path: '/main_home' })
      // 进入首页后需要显示欢迎信息
      // setTimeout(() => {
      //   notification.success(
      //     {
      //       message: '欢迎',
      //       description: `${timeFix()}，欢迎回来`
      //     },
      //     1000
      //   )
      // })
    }
  } else if (to.path === '/login' || to.path === '/login/page') {
    // 如果用户有权限路由到登录则返回首页
    // next({ path: defaultRoutePath })
    // next()
    next('/')
  } else {
    // 其它情况，直接进入下一个路由，因为这个时候to对角还没有实例化，所以跳转到 to.path 的页面
    next({ path: to.redirectedFrom || to.path, replace: true, query: to.query })
  }
  // NProgress.done()
}

router.beforeEach((to, from, next) => {
  Vue.prototype.$destroyAll()
  if (to === from) return // 这一句用来判断当上一个路由和当前路由完全相同的状况
  // 当拖动 tab 标签打开新页面时，query 中不需要有 tab = 1 这个值，所以要去掉
  // 这个时候因为是打开新的浏览器标签页，所以本地标签应该是空的，所以根据这个特性来处理
  const { tabs } = store.getters
  const { query, path } = to || {}
  const { tab, ...otherQuery } = query || {}
  if (tabs.length < 2 && tab) {
    // 因为在这里时地址栏的地址已经变化了，所以需要重新赋值
    // 如果地址栏重新赋值了，这里就没有必要继续往下走了
    const { origin } = window?.location || {}
    const href = `${origin}${process.env.VUE_APP_BASE_URL}${path}?${Qs.stringify(otherQuery)}`
    window.location.replace(href)
  }
  const res = microAppInterception(to, next)
  if (!res) return
  // 灵心首页跳转重定向
  if (to.path === '/ucs/agent') next('/')
  // 任意页面(登录页面除外)跳转过来，只要添加token都保存到cookie中
  if (to.query && to.query.token && !to.path.includes('/login/page')) {
    Vue.prototype.$cookie.set('systemName', 'UCS')
    Vue.prototype.$cookie.set('UCS-AUTHEN-TOKEN', to.query.token)
    Vue.prototype.$cookie.set('sso_sys_token', to.query.token)
    next()
  } else if (Vue.prototype.$cookie.get(ACCESS_TOKEN) && !(to.query && to.query.token && to.path.includes('/login/page'))) { // 如果是从官网跳转过来的页面，即使有token也需要进入登录页面进行重新登录
    /* has token */
    if (!(store.getters.roles && store.getters.roles.length)) {
      // 没有用户信息逻辑
      queryUserInfo(to, from, next).then(() => judgeJump(to, from, next))
    } else {
      next()
    }
  } else {
    // 没有 token
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      confirmLogin(true)
    }
  }
})

router.afterEach(async (to, from) => {
  // 埋点操作
  const { fullPath, path, meta } = to
  const mitoArr = {
    // 首页
    '/main_home': '首页',
    // 总账管理
    '/fins/certificate/list': '凭证列表',
    '/fins/final/final_index': '期末结账',
    '/fins/accountbook/subjectbalance': '科目余额表',
    // 资产管理
    '/fas/admin/maintain/assetsCard_index': '资产卡片',
    '/fas/admin/ending/depreciation': '计提折旧',
    '/fas/admin/ending/checkout': '期末结账',
    // 管理报表
    '/report/reportCenter/reportQuery': '报表查询',
    '/report/reportCenter/multiOrg': '多组织报表编制',
    // 费用管理
    '/ems/normal/reimbursement/my_reim': '我的报销',
    '/ems/normal/document_reviewing/my_auditing': '待我审核',
    '/ems/normal/document_reviewing/my_auditing/detail': '审核详情',
    '/ems/normal/document_reviewing/my_approving': '带我审批',
    '/ems/normal/document_reviewing/my_approving/detail': '审批详情',
    '/ems/normal/settlement/public_settlement': '对公结算',
    '/ems/normal/settlement/public_settlement/detail': '对公结算详情',
    '/ems/normal/settlement/private_settlement': '对私结算',
    '/ems/normal/settlement/private_settlement/detail': '对私结算详情',
    '/ems/normal/corporate_business/public_payment_bills': '对公付款',
    '/ems/normal/statement/const_center_statement': '成本中心报表',
    // 资金管理
    '/fund/fund_settlement/pay_settle/pay_application': '付款申请',
    '/fund/fund_settlement/pay_settle/offline_payments': '线下支付查询',
    '/fund/fund_settlement/bank_payment/query': '银企支付查询'
  }
  if (path in mitoArr) {
    mitoLog(fullPath, mitoArr[path] || meta?.title || '')
  }
  if (!to.name) {
    await toMicroApp(to)
  } else {
    store.commit('SET_MICRO_APP_LOADING', false)
    store.commit('SET_SHOW_MICRO_APP', '')
  }
  if (to.name === 'CommonLogin') {
    store.commit('SET_MICRO_APP_LOADING', false)
    Vue.prototype.$loading.hide()
    return
  }
  const loadingVisible = Vue.prototype.$loading.instance.instance.visible
  if (to.name === from.name && to.name === 'CommonLogin') {
    return
  }
  if (to.name === 'Home') {
    console.log(from)
    if (from.name !== 'Home') {
      !loadingVisible && Vue.prototype.$loading.show()
    }
    store.commit('SET_ACTIVE_PATH', to.path)
  } else {
    Vue.prototype.$loading.hide()
  }
})
if (store.state.user.systemList?.length === 0 && cookies.get(ACCESS_TOKEN)) {
  store.dispatch('GetSystemList')
}

router.onError((error) => {
  const pattern = /Loading (CSS )?chunk (.)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    window.location.replace(window.location.href)
  }
})
